<template>
  <header class="header">
    <slot name="nav-left">
      <div class="btn-con">
        <a href="javascript:;" @click="goBack" class="header-btn"><img src="~@/assets/img/back-icon.png" class="back-icon" /></a>
      </div>
    </slot>
    <h1 class="header-title">{{$route.meta.hideTitle ? '' : myTitle}}</h1>
    <slot name="nav-right"></slot>
  </header>
</template>

<script>
import Storage from '@/utils/Storage'
export default {
  name: 'myHeader',
  props: ['title', 'back'],
  computed: {
    myTitle () {
      return this.title || this.$route.meta.title || 'Hello 部落'
    }
  },
  methods: {
    goBack () {
      if (this.back) {
        this.back()
      } else {
        if (Storage.load('referer')) {
          // 非落地页
          history.go(-1)
        } else {
          this.$router.push({ path: '/' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  .header {
    position: sticky;
    top: 0;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    height: 88px;
    background: #fff;
    .header-title {
      position: absolute;
      left: 50%;
      top: 0;
      color: #38383C;
      font-size: 36px;
      line-height: 88px;
      font-weight: bold;
      transform: translateX(-50%);
    }
    .btn-con {
      width: 100px;
      height: 100%;
    }
    .header-btn {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .back-icon {
      width: 20px;
    }
    .search-icon {
      width: 34px;
    }
  }
</style>
